export function getSponsoredTopic(entry, overrideTypename) {
  const typename = overrideTypename || entry.__typename
  // We special case Topics to refer to give them a "CTA" heading of "Explore"
  // N.B. "Topic" here is the name of a Contentful model content type
  // that is different to this repo's notion of a topic as found in e.g.
  // the name of this file.

  if (
    ['topic', 'experience', 'featuredlink'].includes(typename.toLowerCase())
  ) {
    return 'Explore'
  } else {
    return `${entry.sponsored ? 'Promoted ' : ''}${typename}`
  }
}
